module.exports = __webpack_public_path__ + "assets/icons_person.6a9d4de2.svg";